<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M4.79,782.5l-0.62,5.42l1.93-1.06l-1.57,3.05c-0.78-1.13-2.09-1.87-3.56-1.87c-2.39,0-4.33,1.94-4.33,4.33
	c0,1.29,0.56,2.45,1.46,3.24l-2.84,1.23l1.1-2.52l-5.77-0.66l5.3-1.87l-3.43-2.25h3.93l-4.4-6.98l5.46,4.48l0.13-3.06l2.93,3.55
	L1.3,784l0.93,2.87L4.79,782.5L4.79,782.5z M10.42,787.72L8.38,790l-3,1.08l2.16-2.44L10.42,787.72z M5.3,792.44l2.07,1.15
	l-1.83,0.2l3.2,3.99l-3.79-2.03l3.46,6.73l-5.23-5.36l-0.26,3.01l-1.13-3.51C3.77,796.24,5.26,794.52,5.3,792.44L5.3,792.44z
	 M-1.23,796.1c0.51,0.3,1.08,0.5,1.69,0.57l-3.14,5.71L-1.23,796.1L-1.23,796.1z M0.99,797.45L0.99,797.45l0.48,2.51l-0.81,2.54
	l-0.53-2.67L0.99,797.45z M-4.51,798.01l-1.45,2.03l-2.2,0.52l1.37-1.89L-4.51,798.01z"/>
</svg>

</template>